export default class extends HTMLElement {
  connectedCallback () {
    this.clearChecked()
    this.handleClick = this.handleClick.bind(this)
    this.addEventListener('click', this.handleClick)
  }

  disconnectedCallback () {
    this.removeEventListener('click', this.handleClick)
    window.clearTimeout(this.feedbackTimer)
  }

  async handleClick (event) {
    const text = this.dataset.text || this.innerText.trim()

    if (!navigator.clipboard) {
      if (event.target.tagName !== 'INPUT') {
        alert(`Clipboard not available. Make sure you're using https://\nCopy text: ${text}`)
      }
      return
    }

    await navigator.clipboard.writeText(text)
    this.showFeedback()
  }

  showFeedback () {
    const copyLabel = this.querySelector('[data-copy-label]')
    const copiedLabel = this.querySelector('[data-copied-label]')
    const status = this.querySelector('[data-copy-status]')
    const duration = Number.parseInt(this.dataset.feedbackDuration || '2000', 10)

    if (copyLabel && copiedLabel) {
      copyLabel.hidden = true
      copiedLabel.hidden = false
    }
    if (status) status.textContent = this.dataset.announcement || ''

    window.clearTimeout(this.feedbackTimer)
    this.feedbackTimer = window.setTimeout(() => {
      if (copyLabel && copiedLabel) {
        copyLabel.hidden = false
        copiedLabel.hidden = true
      }
      if (status) status.textContent = ''
      this.clearChecked()
    }, Number.isFinite(duration) ? duration : 2000)
  }

  clearChecked () {
    this.querySelectorAll('input').forEach((e) => {
      e.checked = false
    })
  }
}
